import PropTypes from 'prop-types'

export const appFormPropTypes = {
  formik: PropTypes.shape({
    setFieldValue: PropTypes.func.isRequired,
    touched: PropTypes.object,
    validateForm: PropTypes.func.isRequired,
    values: PropTypes.shape({
      currentMicroapp: PropTypes.shape({
        id: PropTypes.string,
        title: PropTypes.string,
        summary: PropTypes.string,
        url: PropTypes.string,
        iconUrl: PropTypes.string,
        audience: PropTypes.array,
        configuration: PropTypes.shape({
          allowDetailExpand: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
          securityOptions: PropTypes.array,
          domainWhitelist: PropTypes.array,
          contact: PropTypes.shape({
            link: PropTypes.string
          })
        })
      })
    })
  })
}
